import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  tone?: "light" | "dark";
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  tone = "light",
  className = ""
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className={`text-center ${className}`} data-id="element-52" data-mp="3k06sdhx8u5sg">
      {eyebrow && <p className={`mb-3 text-sm font-bold uppercase tracking-[0.14em] ${dark ? "text-gold-400" : "text-gold-600"}`} data-id="element-53" data-mp="3k29kc7hyi8zt">{eyebrow}</p>}
      <h2 className={`font-serif text-[30px] font-bold leading-[1.15] sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-54" data-mp="gjzslmhy8soy">
        {title}
      </h2>
    </div>;
}